module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loadingCaseForms) ? _c('v-progress-linear', {
    attrs: {
      "indeterminate": _vm.loadingCaseForms
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.loadingCaseForms) ? _c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-subheader', {
    staticClass: "required"
  }, [_vm._v("Client salutation:")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Salutation",
      "items": [
        'Mr',
        'Miss',
        'Mrs',
        'Mdm',
        'Dr'
      ]
    },
    model: {
      value: (_vm.localMainForm.salutation),
      callback: function($$v) {
        _vm.$set(_vm.localMainForm, "salutation", $$v)
      },
      expression: "localMainForm.salutation"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-subheader', {
    staticClass: "required"
  }, [_vm._v("Relationship with deceased:")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Relationship with deceased",
      "rules": _vm.relationshipWithDeceasedRules,
      "items": [
        'Husband',
        'Wife',
        'Son',
        'Daughter',
        'Father',
        'Mother',
        'Father in law',
        'Mother in law',
        'Son in law',
        'Daughter in law',
        'Brother',
        'Sister',
        'Brother in law',
        'Sister in law',
        'Uncle',
        'Auntie',
        'Nephew',
        'Niece',
        'Cousin',
        'Friend',
        'Social worker',
        'Others'
      ]
    },
    model: {
      value: (_vm.localMainForm.relationship_with_deceased),
      callback: function($$v) {
        _vm.$set(_vm.localMainForm, "relationship_with_deceased", $$v)
      },
      expression: "localMainForm.relationship_with_deceased"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h3', {
    staticStyle: {
      "margin-bottom": "20px",
      "margin-top": "20px"
    }
  }, [_vm._v("Deceased's Details")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-subheader', {
    staticClass: "required"
  }, [_vm._v("Date of Death:")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-menu', [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "readonly": "",
      "rules": _vm.dateRules
    },
    slot: "activator",
    model: {
      value: (_vm.localMainForm.deceased_date),
      callback: function($$v) {
        _vm.$set(_vm.localMainForm, "deceased_date", $$v)
      },
      expression: "localMainForm.deceased_date"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "reactive": ""
    },
    model: {
      value: (_vm.localMainForm.deceased_date),
      callback: function($$v) {
        _vm.$set(_vm.localMainForm, "deceased_date", $$v)
      },
      expression: "localMainForm.deceased_date"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-subheader', {
    staticClass: "required"
  }, [_vm._v("Deceased Gender:")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": ['M', 'F'],
      "rules": _vm.genderRules
    },
    model: {
      value: (_vm.localMainForm.deceased_gender),
      callback: function($$v) {
        _vm.$set(_vm.localMainForm, "deceased_gender", $$v)
      },
      expression: "localMainForm.deceased_gender"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-subheader', {
    staticClass: "required"
  }, [_vm._v("Deceased Name:")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "rules": _vm.deceasedNameRules
    },
    model: {
      value: (_vm.localMainForm.deceased_name),
      callback: function($$v) {
        _vm.$set(_vm.localMainForm, "deceased_name", $$v)
      },
      expression: "localMainForm.deceased_name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-subheader', [_vm._v("Deceased Chinese Name:")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-text-field', {
    model: {
      value: (_vm.localMainForm.deceased_name_chinese),
      callback: function($$v) {
        _vm.$set(_vm.localMainForm, "deceased_name_chinese", $$v)
      },
      expression: "localMainForm.deceased_name_chinese"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-subheader', {
    staticClass: "required"
  }, [_vm._v("Deceased Age:")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "rules": _vm.ageRules
    },
    model: {
      value: (_vm.localMainForm.deceased_age),
      callback: function($$v) {
        _vm.$set(_vm.localMainForm, "deceased_age", $$v)
      },
      expression: "localMainForm.deceased_age"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-subheader', [_vm._v("Death Certificate No:")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-text-field', {
    model: {
      value: (_vm.localMainForm.deceased_death_certificate_no),
      callback: function($$v) {
        _vm.$set(_vm.localMainForm, "deceased_death_certificate_no", $$v)
      },
      expression: "localMainForm.deceased_death_certificate_no"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-subheader', {
    staticClass: "required"
  }, [_vm._v("Religion:")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": [
        'Buddhist',
        'Taoist',
        'Catholic',
        'Christian',
        'Free thinker',
        'Hindu',
        'Soka',
        'Others'
      ],
      "rules": _vm.religionRules
    },
    model: {
      value: (_vm.localMainForm.deceased_religion),
      callback: function($$v) {
        _vm.$set(_vm.localMainForm, "deceased_religion", $$v)
      },
      expression: "localMainForm.deceased_religion"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-subheader', {
    staticClass: "required"
  }, [_vm._v("Dialect:")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": [
        'Cantonese',
        'Hainanese',
        'Hakka',
        'Hokchew',
        'Hokkien',
        'Kerk',
        'Shanghainese',
        'Tamil',
        'Teochew',
        'Others'
      ],
      "rules": _vm.dialectRules
    },
    model: {
      value: (_vm.localMainForm.deceased_dialect),
      callback: function($$v) {
        _vm.$set(_vm.localMainForm, "deceased_dialect", $$v)
      },
      expression: "localMainForm.deceased_dialect"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-subheader', {
    staticClass: "required"
  }, [_vm._v("Location of Wake:")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "rules": _vm.locationOfWakeRules
    },
    model: {
      value: (_vm.localMainForm.deceased_location_of_wake),
      callback: function($$v) {
        _vm.$set(_vm.localMainForm, "deceased_location_of_wake", $$v)
      },
      expression: "localMainForm.deceased_location_of_wake"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-subheader', [_vm._v("Crematorium / Burial Location:")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.burialLocations,
      "clearable": ""
    },
    model: {
      value: (_vm.localMainForm.deceased_burial_location),
      callback: function($$v) {
        _vm.$set(_vm.localMainForm, "deceased_burial_location", $$v)
      },
      expression: "localMainForm.deceased_burial_location"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-subheader', [_vm._v("Embalming:")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-checkbox', {
    model: {
      value: (_vm.localMainForm.deceased_embalming),
      callback: function($$v) {
        _vm.$set(_vm.localMainForm, "deceased_embalming", $$v)
      },
      expression: "localMainForm.deceased_embalming"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-subheader', [_vm._v("TERMS & CONDITIONS ("), _c('a', {
    staticClass: "link",
    on: {
      "click": function($event) {
        return _vm.openDialog('en')
      }
    }
  }, [_vm._v("Click to Open and Read")]), _vm._v(")")])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "ph16",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "rules": _vm.termsAndConditionsRules,
      "label": "I acknowledge that our funeral director has shown and clearly explained the terms and conditions of products and services. In addition, I confirm that I have fully understood and agree to the terms and conditions stated above."
    },
    on: {
      "change": function($event) {
        return _vm.openDialog('en')
      }
    },
    model: {
      value: (_vm.localMainForm.terms),
      callback: function($$v) {
        _vm.$set(_vm.localMainForm, "terms", $$v)
      },
      expression: "localMainForm.terms"
    }
  }), _vm._v(" "), _c('br')], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "hide-overlay": "",
      "transition": "dialog-bottom-transition"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v(_vm._s(_vm.dialogTitle))]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), (_vm.dialogLang === 'en') ? _c('TermsInEnglish') : _c('TermsInMandarin')], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0103d6c1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/resources/Forms.vue
// module id = 946
// module chunks = 1